module.exports = __webpack_public_path__ + "media/public/images/error/posts-b77e916d1c5d392418248d8478bc9290.jpg";